/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from "react";
import { Action } from "../../../components/ActionsCard/ActionCard";
import { ActionCardWithFeedback } from "../../../components/ActionsCardWithFeedback/ActionsCardWithFeedback";

export type CardProps = {
    className?: string;
    actions?: Action[];
    titleLines?: string[];
};

const ConversionTrialsListSidePane: React.FC<CardProps> = ({ className, actions, titleLines }) => {

    return (
        <div className={className}>
            <ActionCardWithFeedback actions={actions} titleLines={titleLines} />
        </div>
    );
};

export default ConversionTrialsListSidePane;